import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export const url = '/libraries/management/types/materialFamily/entries'

export interface MaterialFamily extends LibraryModel {
    key: string
    new?: boolean
}

@Injectable()
export class MaterialFamilyService {
    constructor(private http: HttpService) {}

    getAll(): Observable<MaterialFamily[]> {
        return this.http.get(url)
    }

    remove(data: MaterialFamily[]): Observable<boolean> {
        return this.http.delete(url, { data })
    }

    create(data: MaterialFamily[]): Observable<unknown> {
        return this.http.post(url, { data })
    }
    update(data: MaterialFamily[]): Observable<unknown> {
        return this.http.put(url, { data })
    }
}
